import './installCompositionApi.js'
import Vue from 'vue'
import App from './App.vue'
// import router from './Router'
import router from './router/Routes'
    

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2)



// Vue.config.devtools = false;

// Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
